import React  from 'react'

import OnSchedCalendar from '../../components/OnSchedCalendar/OnSchedCalendar'


const Calendar = element => {
  return (
    <OnSchedCalendar element={element} />
  )
}

export default Calendar
